/** eslint-disable prettier/prettier */
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpClient) { }
  singlePromeise: any;
  sessionPromise: any;
  public static readonly SOEWEB_CALLBACK: number = 1;
  public static readonly SOEWEB_VINCULAR: number = 2;
  public static readonly DROPBOX_CALLBACK: number = 3;
  public static readonly DROPBOX_VINCULAR: number = 4;

  setRedirectTo(redirectTo: string) {
    sessionStorage.setItem('system.redirectto', redirectTo);
  }
  getRedirectTo(): string {
    return sessionStorage.getItem('system.redirectto');
  }

  cleanJWT() {
    sessionStorage.removeItem('system.jwt');
  }
  getJWT() {
    this.singlePromeise = new Promise((resolve, reject) => {
      var token = sessionStorage.getItem('system.jwt');
      if (token) {
        resolve(token);
      } else {
        this.http
          .post(environment.apiUrl + '/login', 
            {},
            {
              withCredentials: true,
              observe: 'response',
            }
          ).subscribe(
            (data1: any) => {
              var token = data1.headers.get('X-Token');
              var session = data1?.body?.entidade;
              try {
                sessionStorage.setItem('system.jwt', token);
                sessionStorage.setItem('system.session', session);
                resolve(token);
              } catch (e) {
                reject('Erro ao salvar database(system.jwt): ' + e);
              }
            },
            (error: HttpErrorResponse) => {
              if (error.status == 0) {
                reject(null);
              }
              if (error.status == 403) {
                reject('Erro 403');
              } else {
                reject(
                  'Erro ao comunicar com servidor de autenticacao: ' +
                  error.message
                );
              }
            }
          );
      }
    });
    return this.singlePromeise;
  }

  cleanSession(){
    sessionStorage.removeItem('system.session');
  }
  getSession(){
    this.sessionPromise = new Promise((resolve, reject) => {
      var session = sessionStorage.getItem('system.session');
      if (session) {
        resolve(session);
      }
      else{
        reject('Erro ao pegar a entidade');
      }
    });
    return this.sessionPromise;
  }
  
  setSession(session: any){
    sessionStorage.setItem('system.session', session);
  }

  autorize(params: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(
        environment.apiUrl + '/login', 
        params,
        { withCredentials: true, observe: 'response' })
        .subscribe(
          (data1: any) => {
            var token = data1.headers.get('X-Token');
            var session = data1?.body?.entidade;
            try {
              sessionStorage.setItem('system.jwt', token);
              sessionStorage.setItem('system.session', session);
              resolve(data1.body.url);
            } catch (e) {
              reject('Erro ao salvar database(system.jwt): ' + e);
            }
          },
          (error: HttpErrorResponse) => {
            if (error.status == 0) {
              reject(null);
            } else {
              reject(error.error);
            }
          }
        );
    });
  }
  userInfo(): Promise<any> {
    return this.http
      .get(environment.apiUrl + '/minha-info')
      .toPromise();
  }
  logout(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (environment.production == true) {
        this.http
          .get(environment.serverUrl + '/logout').subscribe(() => {
            this.cleanJWT();
            resolve(true);
          }, (error: HttpErrorResponse) => {
            reject(error.message);
          });
      } else {
        this.cleanJWT();
        resolve(true);
      }
    });

  }
  logout2(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(environment.apiUrl + '/logout').subscribe(() => {
          this.cleanJWT();
          resolve(true);
        }, (error: HttpErrorResponse) => {
          reject(error.message);
        });
      
      resolve(true);
    });

  }
  soewebAuthentication(): Promise<any> {
    return new Promise((resolve, reject) => {
      let p = new URLSearchParams({
        redirect_uri: environment.clientUrl + '/valid-login/soeweb-callback',
      }).toString();
      this.http
        .get(environment.apiUrl + '/public/soeweb-authentication?' + p)
        .subscribe((data1: any) => {
            resolve(data1['url']);
          },
          (error: HttpErrorResponse) => {
            reject(error.message);
          }
        );
    });
  }
  soewebLogin(code: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let p = {
        code: code,
        redirect_uri: environment.clientUrl + '/valid-login/soeweb-callback',
      };
      this.http
        .post(environment.apiUrl + '/public/soeweb-login?', p, {
          withCredentials: true,
          observe: 'response',
        })
        .subscribe((data1: any) => {
            var token = data1.headers.get('X-Token');
            try {
              sessionStorage.setItem('system.jwt', token);
              resolve(data1.body);
            } catch (e) {
              reject('Erro ao salvar database(system.jwt): ' + e);
            }
          },
          (error: any) => {
            if (error.status == 0) {
              reject(null);
            } else {
              reject('Erro : ' + error.error.message);
            }
          }
        );
    });
  }
  dropboxAuthentication(): Promise<any> {
    return new Promise((resolve, reject) => {
      let p = new URLSearchParams({
        redirect_uri: environment.clientUrl + '/valid-login/dropbox-callback',
      }).toString();
      this.http
        .get(environment.apiUrl + '/public/dropbox-authentication?' + p)
        .subscribe((data1: any) => {
            resolve(data1['url']);
          },
          (error: HttpErrorResponse) => {
            reject(error.message);
          }
        );
    });
  }
  dropboxLogin(code: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let p = {
        code: code,
        redirect_uri: environment.clientUrl + '/valid-login/dropbox-callback',
      };
      this.http
        .post(environment.apiUrl + '/public/dropbox-login?', p, {
          withCredentials: true,
          observe: 'response',
        })
        .subscribe((data1: any) => {
            var token = data1.headers.get('X-Token');
            try {
              sessionStorage.setItem('system.jwt', token);
              resolve(data1.body);
            } catch (e) {
              reject('Erro ao salvar database(system.jwt): ' + e);
            }
          },
          (error: any) => {
            if (error.status == 0) {
              reject(null);
            } else {
              reject('Erro : ' + error.error.message);
            }
          }
        );
    });
  }
  soewebVincularAuthentication(): Promise<any> {
    return new Promise((resolve, reject) => {
      let p = new URLSearchParams({
        redirect_uri: environment.clientUrl + '/valid-login/soeweb-vincular',
      }).toString();
      this.http
        .get(environment.apiUrl + '/public/soeweb-authentication?' + p)
        .subscribe((data1: any) => {
            resolve(data1['url']);
          },
          (error: HttpErrorResponse) => {
            reject(error.message);
          }
        );
    });
  }
  soewebVincular(code: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let p = {
        code: code,
        redirect_uri: environment.clientUrl + '/valid-login/soeweb-vincular',
      };
      this.http
        .post(environment.apiUrl + '/soeweb-vincular?', p, {
          withCredentials: true,
          observe: 'response',
        })
        .subscribe((data1: any) => {
            try {
              resolve('/');
            } catch (e) {
              reject('Erro ao redirecionar: ' + e);
            }
          },
          (error: any) => {
            if (error.status == 0) {
              reject(null);
            } else {
              reject('Erro : ' + error.error.message);
            }
          }
        );
    });
  }
  dropboxVincularAuthentication(): Promise<any> {
    return new Promise((resolve, reject) => {
      let p = new URLSearchParams({
        redirect_uri: environment.clientUrl + '/valid-login/dropbox-vincular',
      }).toString();
      this.http
        .get(environment.apiUrl + '/public/dropbox-authentication?' + p)
        .subscribe((data1: any) => {
            resolve(data1['url']);
          },
          (error: HttpErrorResponse) => {
            reject(error.message);
          }
        );
    });
  }
  dropboxVincular(code: string): Promise<any> {
    return new Promise((resolve, reject) => {
      let p = {
        code: code,
        redirect_uri: environment.clientUrl + '/valid-login/dropbox-vincular',
      };
      this.http
        .post(environment.apiUrl + '/dropbox-vincular?', p, {
          withCredentials: true,
          observe: 'response',
        })
        .subscribe((data1: any) => {
            try {
              resolve('/');
            } catch (e) {
              reject('Erro ao redirecionar: ' + e);
            }
          },
          (error: any) => {
            if (error.status == 0) {
              reject(null);
            } else {
              console.log(error);
              reject('Erro : ' + error.error.message);
            }
          }
        );
    });
  }
}
